import './confirm_modal.less';

import classnames         from 'classnames';
import Modal              from './modal';
import React              from 'react';

import { X as CloseIcon } from 'react-feather';


export default function ConfirmModal({
  isOpen,
  closeModal,
  className,
  onConfirm,
  title,
  description,
  buttonLabel,
  buttonClassName
}) {
  const modalClassNames  = classnames('confirm-modal', className);
  const buttonClassNames = classnames('button', 'button-fill', buttonClassName);

  return (
    <Modal isOpen={isOpen} closeModal={closeModal} className={modalClassNames}>
      <div className="close-icon" onClick={closeModal}>
        <CloseIcon/>
      </div>
      {title && <h2 className="title">{title}</h2>}
      {description && <p className="description">{description}</p>}
      <div className="actions">
        <button className={buttonClassNames} onClick={onConfirm}>{buttonLabel}</button>
      </div>
    </Modal>
  );
}
